document.getElementById('upload-image').addEventListener('change', function(event) {
    const file = event.target.files[0];
    if (file) {
        const reader = new FileReader();
        reader.onload = function(e) {
            let uploadedImage = new Image();
            uploadedImage.src = e.target.result;
            uploadedImage.onload = function() {
                document.querySelectorAll('.tshirt').forEach(tshirt => {
                    let canvas = document.createElement('canvas');
                    let ctx = canvas.getContext('2d');

                    // Set canvas size equal to the T-shirt image size
                    canvas.width = tshirt.clientWidth;
                    canvas.height = tshirt.clientHeight;

                    // Draw the T-shirt first
                    ctx.drawImage(tshirt, 0, 0, canvas.width, canvas.height);

                    // Resize and position the uploaded image correctly
                    const imgWidth = canvas.width * 0.4; // 10% of T-shirt width
                    const imgHeight = imgWidth * (uploadedImage.height / uploadedImage.width); // Maintain aspect ratio
                    const xPosition = (canvas.width - imgWidth) / 2; // Center horizontally
                    const yPosition = canvas.height * 0.3; // Move slightly down

                    ctx.drawImage(uploadedImage, xPosition, yPosition, imgWidth, imgHeight);

                    // Convert canvas to image and update T-shirt display
                    tshirt.src = canvas.toDataURL('image/png');
                });
            };
        };
        reader.readAsDataURL(file);
    }
});
